import request from '@/src/apis/axios';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import { PushAlarmInfoDto } from '@/src/models/PushAlarmInfoDto';
import {
  GetPushAlarmInfoRequestParams,
  UpsertPushAlarmInfoRequestBody,
} from '@/src/apis/rest/pushAlarm.dtos';

const URL = {
  pushAlarmInfo: '/admin/push-alarm-information',
  pushAlarmInfoDetail: '/admin/push-alarm-information/{id}',
  pushAlarmCategory: '/push-alarm-information/push-category-type',
  pushAppPageCategory:
    '/push-alarm-information/push-app-page-connection-category-type',
  pushAlarmInfoExcel: '/admin/push-alarm-information/excel/export',
};

export const getPushAlarmInfosAPI = async (
  requestParams: Partial<GetPushAlarmInfoRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<PushAlarmInfoDto>>({
    method: 'get',
    url: URL.pushAlarmInfo,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(PushAlarmInfoDto, data.rows);

  return { rows, count: data.count };
};

export const getPushAlarmInfoByIdAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<PushAlarmInfoDto>>({
    method: 'get',
    url: URL.pushAlarmInfoDetail.replace('{id}', String(id)),
  });

  return plainToInstance(PushAlarmInfoDto, data.row);
};

export const postPushAlarmInfoAPI = async (
  requestBody: Partial<UpsertPushAlarmInfoRequestBody>,
) => {
  const { data } = await request<ObjectResponse<PushAlarmInfoDto>>({
    method: 'post',
    url: URL.pushAlarmInfo,
    requestBody,
  });

  return plainToInstance(PushAlarmInfoDto, data.row);
};

export const putPushAlarmInfoAPI = async (
  id: number,
  requestBody: Partial<UpsertPushAlarmInfoRequestBody>,
) => {
  const { data } = await request<ObjectResponse<PushAlarmInfoDto>>({
    method: 'put',
    url: URL.pushAlarmInfoDetail.replace('{id}', String(id)),
    requestBody,
  });

  return plainToInstance(PushAlarmInfoDto, data.row);
};

export const deletePushAlarmInfoAPI = async (id: number) => {
  const { data } = await request({
    method: 'delete',
    url: URL.pushAlarmInfoDetail.replace('{id}', String(id)),
  });

  return data;
};

export const getPushAlarmCategoryAPI = async () => {
  const { data } = await request<ListResponse<{ key: string; value: string }>>({
    method: 'get',
    url: URL.pushAlarmCategory,
  });

  return data.rows;
};

export const getPushAppPageConnectionCategoryAPI = async () => {
  const { data } = await request<ListResponse<{ key: string; value: string }>>({
    method: 'get',
    url: URL.pushAppPageCategory,
  });

  return data.rows;
};

export const getPushAlarmInfoExcelAPI = async (
  password: string,
  { id }: { id: number },
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.pushAlarmInfoExcel,
    queryParams: { id, password },
    config: { responseType: 'blob' },
  });

  return data;
};
